import React, { Fragment, useEffect, useState } from 'react';
import logo from './assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { Styling } from './types/customer';

function Header() {
  const [bgColor, setBgColor] = useState<{ backgroundColor: string } | null>(null);

  useEffect(() => {
    // const isHomePage = window.location.pathname === '/';
    // if (isHomePage) {
    setBgColor({ backgroundColor: Styling.PrimaryColor() });
    // } else {
    // setBgColor({ backgroundColor: '#8B2560' });
    // }
  }, []);

  return (
    <Fragment>
      {bgColor && (
        <div className="header" style={bgColor}>
          <Link to="/">
            <img src={logo} alt="logo thuisleefgroep" style={{ height: '3em', marginLeft: '0.5em' }} />
          </Link>
          { window.customer && window.customer.header_images && Array.isArray(window.customer.header_images) && (
          <>
            <div className="flex-1"></div>
            <div className="extra-logos">
            { window.customer.header_images.map((imgSrc: string, index: number) =>
              <div key={index} className="logo-container"><img className="logo" src={ imgSrc } /></div>
            )}
            </div>
          </>
          )}
        </div>
      )}
    </Fragment>
  );
}

export default Header;
